export default "__VITE_ASSET__B5$X6FTA__"